import { identity } from '../../utils/function'
import { pickBy } from '../../utils/object'

export const removeEmptyKeyValuePairs = object => {
  return pickBy(object, identity)
}

export default removeEmptyKeyValuePairs
